module.exports = __webpack_public_path__ + "static/media/finenets.f6711135.png";